import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider } from '@mui/material';
import * as React from 'react';
import { ComponentThreeViewCompare } from 'shared/device.z3k.tree-view-compare/ui';
import { useEffect, useRef } from 'react';
export const ResultCompareConfig = (props) => {
    const { resultCompare, count, onCheckNewConfig, newSetter } = props;
    const flagAllCheckbox = useRef({ checked: false });
    useEffect(() => {
        if (flagAllCheckbox.current.checked &&
            newSetter.filter((i) => !i.flag).length <= count) {
            flagAllCheckbox.current = { checked: false };
        }
    }, [flagAllCheckbox.current]);
    return (_jsx(_Fragment, { children: _jsx(Box
        // display="grid"
        , { 
            // display="grid"
            display: "flex", justifyContent: "space-between", children: resultCompare && (_jsxs(_Fragment, { children: [_jsx(ComponentThreeViewCompare, { title: "\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0438\u0437 \u0444\u0430\u0439\u043B\u0430", resultCompare: resultCompare, keyResult: "new", onCheckNewConfig: onCheckNewConfig, newSetter: newSetter, flagAllCheckbox: flagAllCheckbox }, `${flagAllCheckbox}+'new'`), _jsx(Divider, { orientation: "vertical", flexItem: true }), _jsx(ComponentThreeViewCompare, { title: "\u0422\u0435\u043A\u0443\u0449\u0438\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043F\u0440\u0438\u0431\u043E\u0440\u0430", resultCompare: resultCompare, keyResult: "old", onCheckNewConfig: onCheckNewConfig, newSetter: newSetter, flagAllCheckbox: flagAllCheckbox }, `${flagAllCheckbox}+'old'`)] })) }) }));
};
